// Scroll-in fade for text (2026-10-12): rich text paragraphs and headings (.prose, every block)
// and each block's own headings and plain-text descriptions (plus a few whole cards/media). The RTE output can't carry the data-scroll-reveal attributes
// itself, so this adds them (plus data-fade-in, which globals.css fades on), and scroll-reveal.ts
// (which must run after this) does the observing - once per element.
//
// Only set from JS, so without JS (or with reduced motion, skipped here) the text is simply
// shown as authored - nothing is ever server-rendered in its hidden state.
//
// Not here on purpose: the Standard Hero heading, Block Quote and the footer CTA have their own
// color sweeps. Rows added later by JS (e.g. "load more" press releases) aren't picked up.

const FADED = [
    // Every heading the same way, whatever its level or size class (incl. ones with no size class,
    // which get prose.css's fallback size).
    ".prose :is(p, h1, h2, h3, h4, h5, h6)",
    ".block-card-links__headline",
    ".card-link__heading",
    ".card-link__description",
    ".block-company-listing__division-heading",
    ".block-company-timeline__headline",
    // Fades in on scroll only - on a year switch it counts instead (block-company-timeline.ts).
    ".block-company-timeline__year-heading",
    ".block-company-timeline__companies > li",
    ".block-company-listing__division-description",
    ".block-contact-cards__heading",
    // Contact cards fade in whole (grid: the card button, list: the card + its fold-out bio),
    // rather than their name/title texts.
    ".contact-card--grid",
    ".contact-card-wrapper",
    ".block-cta__heading",
    ".block-cta__media",
    ".block-editorial-richtext__heading",
    ".block-news-and-press-list__heading",
    ".block-news-and-press-list__card-heading",
    ".block-press-release-list-items__heading",
    ".block-text-items__label",
    ".block-text-items__large-text",
    // Umbraco Forms field wrapper (Form.cshtml's SetFormFieldWrapperClass). A field shown later
    // by a form condition was never intersecting while hidden, so it fades in once it appears.
    ".dacke-form-field",
].join(", ");

export function initFadeIn(): void {
    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
    }

    document.querySelectorAll<HTMLElement>(FADED).forEach((element) => {
        element.dataset.fadeIn = "";
        element.dataset.scrollReveal = "";
        element.dataset.scrollRevealOnce = "";
        element.dataset.scrollState = "leave";
    });
}
